
import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import VideosPage from '../../pages/admin/VideosPage';
import UsersPage from '../../pages/admin/UsersPage';
import FiltersPage from '../../pages/admin/FiltersPage';
import CompaniesPage from '../../pages/admin/CompaniesPage';
import AddVideoPage from '../../pages/admin/AddVideoPage';
import VideoDetailPage from '../../pages/admin/VideoDetailPage';
import ManageCompanyFiltersPage from '../../pages/admin/ManageCompanyFiltersPage';
import CompanyVideosPage from '../../pages/admin/CompanyVideosPage';
import SuperAdminUsersPage from '../../pages/admin/SuperAdminUsersPage';
import KpisPage from '../../pages/admin/KpisPage';
import ManageCompanyKpisPage from '../../pages/admin/ManageCompanyKpisPage';
import PdfSettingsPage from '../../pages/admin/PdfSettingsPage';
import TenantsPage from '../../pages/admin/TenantsPage';
import { AuthContext } from '../../contexts/AuthContext';
import { UserRole } from '../../types';

const DashboardLayout: React.FC = () => {
  const authContext = useContext(AuthContext);
  const isPlatformOwner = authContext?.user?.role === UserRole.PLATFORM_OWNER;
  const defaultPath = isPlatformOwner ? '/tenants' : '/videos';

  return (
    <div className="flex h-screen bg-black text-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-black p-6">
          <Routes>
            <Route path="/" element={<Navigate to={defaultPath} replace />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/videos/new" element={<AddVideoPage />} />
            <Route path="/videos/:videoId" element={<VideoDetailPage />} />
            <Route path="/videos/company/:companyId" element={<CompanyVideosPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/platform-users" element={<SuperAdminUsersPage />} />
            <Route path="/filters" element={<FiltersPage />} />
            <Route path="/filters/:companyId" element={<ManageCompanyFiltersPage />} />
            <Route path="/kpis" element={<KpisPage />} />
            <Route path="/kpis/:companyId" element={<ManageCompanyKpisPage />} />
            <Route path="/pdf-settings" element={<PdfSettingsPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="*" element={<Navigate to={defaultPath} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
